<template>
    <div class="form-box">
        <div class="box-head">
            <p style="width:60%">所有项目汇总表</p>
            <!-- <el-input placeholder="请输入项目名称" v-model="proName" class="input-with-select" style="margin-left:1vw;"></el-input> -->
            <el-input placeholder="请输入项目名称" v-model="proName" class="input-with-select" style="margin-left:1vw;">
                <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
            </el-input>

        </div>
        <!-- <div class="box-head" style="border:0">
            <div style="width:20%;text-align:left;color:#f00">合计:</div>
            <ul class="ul-s">
                <li class="li-16" style="width:12%;">合同价:{{entity.contractPrice}}</li>
                <li class="li-16" style="width:15%;">累计审定产值:{{entity.judgementValue}}</li>
                <li class="li-16" style="width:18%;">累计工程款支付:{{entity.actualPayment}}</li>
                <li class="li-16" style="width:20%;">累计农民工专户支付:{{entity.specialAccount}}</li>
                <li class="li-16" style="width:20%;">农民工专户支付比例:{{entity.specialAccountRatio}}</li>
                <li class="li-16" style="width:12%;">违约金:{{entity.fine}}</li>
            </ul>
        </div> -->
        <div class="box-main">
            <el-table :data="tableData" border style="width: 100%" height="100%" :row-class-name="tableRowClassName" :header-row-class-name="'table-head'" >
                <template slot="empty">
                    <p>{{dataText}}</p>
                </template>
                <el-table-column prop="index" label="汇总">
                    <el-table-column prop="index" label="序号" width="100">
                        <template slot-scope="scope">
                            <span>{{scope.row.index}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="entProjectName" label="项目名称" >
                        <template slot-scope="scope">
                            <a  class="nameStyle" @click="rowClick(scope.row)">{{scope.row.entProjectName}}</a>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column :label="entity.contractPrice">
                    <el-table-column prop="contractPrice" label="合同价">
                        <template slot-scope="scope">
                            <span>{{scope.row.toatlParice}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column :label="entity.judgementValue">
                    <el-table-column prop="status" label="累计审定产值">
                        <template slot-scope="scope">
                            <p>{{scope.row.total0}}</p>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column :label="entity.actualPayment">
                    <el-table-column prop="num" label="累计工程款支付">
                        <template slot-scope="scope">
                            <span >{{scope.row.total2}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column :label="entity.specialAccount">
                    <el-table-column prop="num" label="累计农民工专户支付">
                        <template slot-scope="scope">
                            <span >{{scope.row.total3}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column :label="entity.specialAccountRatio">
                    <el-table-column prop="num" label="农民工专户支付比例">
                        <template slot-scope="scope">
                            <span >{{scope.row.bilv}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column :label="entity.fine">
                    <el-table-column prop="num" label="违约金">
                        <template slot-scope="scope">
                            <span >{{scope.row.total4}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <!-- <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="success" @click="infoFun(scope.row)">查看</el-button>
                    </template>
                </el-table-column> -->
            </el-table>
        </div>
        <!--  -->
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalItems"
        ></el-pagination>
    </div>
</template>

<script>
import myHttp from '../../../untils/port';
import util from '../../../untils/util';
export default {
    data(){
        return{
            groupId:'',
            tableData:[],
            currentPage: 1,
            pageSize: 10,
            totalItems: 0,
            proName:'',
            contractName:'',
            dataText: '数据加载中...',
            entity:{
                actualPayment: 0,
                contractPrice: 0,
                fine: 0,
                judgementValue: 0,
                specialAccount: 0,
                specialAccountRatio: 0,

            }
            // spanArr: [],
            // pos: 0
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getData()
        this.getToltal()
    },
    methods:{
        doFilter(){
            this.currentPage = 1
            this.getData()
              this.getToltal()
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.currentChangePage()
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getData()
        },
        //获取列表
        getData(){
            var that = this
            myHttp.getEntProjectListPaysByEntId({
                entId:this.groupId,
                entProjectName:this.proName,
                contractName:this.contractName,
                pageNum:this.currentPage,
                pageSize:this.pageSize,
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data.entProject.list||[]
                    // var total=0
                    for(var i=0;i<list.length;i++){
                        list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                        // 合同总价
                        if(list[i].proPays.length==0||!list[i].proPays){
                            list[i].toatlParice=0
                            list[i].total0=0
                            list[i].total3=0
                            list[i].total2=0
                            list[i].total4=0
                            list[i].bilv=0
                        }else{
                            list[i].toatlParice=0
                            list[i].total0=0
                            list[i].total2=0
                            list[i].total3=0
                            list[i].total4=0
                            list[i].proPays.forEach((item,index)=>{
                             item.contractPrice =item.contractPrice ? parseFloat(item.contractPrice):0
                             list[i].toatlParice+=parseFloat(item.contractPrice)
                             item.first= item.first?JSON.parse(item.first):{list:0,total:0,total2:0,total3:0,total4:0}
                             item.first.total0= item.first.total0 ? parseFloat(item.first.total0):0
                             list[i].total0+=parseFloat(item.first.total0)
                             item.first.total2= item.first.total2 ? parseFloat(item.first.total2):0
                             list[i].total2+=parseFloat(item.first.total2)
                             item.first.total3= item.first.total3 ? parseFloat(item.first.total3):0
                             list[i].total3+=parseFloat(item.first.total3)
                             item.first.total4= item.first.total4 ? parseFloat(item.first.total4):0
                             list[i].total4+=parseFloat(item.first.total4)
                             list[i].firstAll = list[i].total2 + list[i].total4
                             list[i].bilv = list[i].total2==0&&list[i].total4==0?0:(parseFloat(list[i].total3)/parseFloat(list[i].firstAll)*100).toFixed(2)+'%'
                           })
                        }
                        // list[i].first = list[i].first?JSON.parse(list[i].first):{list:0,total:0,total2:0,total3:0,total4:0}
                        // list[i].first.total2 = list[i].first.total2?list[i].first.total2:0 
                        // list[i].first.total4 = list[i].first.total4?list[i].first.total4:0 
                        //  list[i].first.total3 = list[i].first.total3?list[i].first.total3:0 
                        // list[i].firstAll = list[i].first.total2 + list[i].first.total4
                        // list[i].first.bilv =list[i].first.total2==0&&list[i].first.total4==0?0:(parseFloat(list[i].first.total3)/parseFloat(list[i].firstAll)*100).toFixed(2)+'%'
                    }
                    that.tableData = list
                    if(list.length==0){
                        that.dataText = '暂无数据'
                    }
                    that.totalItems = resp.data.data.entProject.total
                }else{
                     that.dataText = '暂无数据'
                }
            })
        },
        /**统计汇总 */ 
        getToltal(){
            var that = this
          myHttp.selectTotalPayCount({
                entId:this.groupId,
                entProjectName:this.proName,
                contractName:this.contractName,
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data.entity
                    that.entity =list
                    
                }else{
                     that.dataText = '暂无数据'
                }
            })
        },
        //
        tableRowClassName({row, rowIndex}) {
            if (rowIndex%2==0) {
                return 'grey-row';
            }
            return '';
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 1) {
                const _row = this.spanArr[rowIndex]
                const _col = _row > 0 ? 1 : 0
                return {
                rowspan: _row,
                colspan: _col
                }
            }
       },
        //查看
        infoFun(row){

        },
        //返回
        goBack(){
            this.$router.go(-1)
        },
        // 查看单个
        rowClick(row){
            console.log(row)
            this.$router.push({path:'/form6/'+row.entProjectId+'/'+row.entProjectName,})
        }
    }
}
</script>

<style scoped>
    .form-box{
        width: 100%;
        height: 100%;
        position: relative;
        padding: 1vh;
    }
    .box-head{
        width: 100%;
        height: 7vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 0 1vw;
        background: #fff;
        border-bottom: 1px solid #4877E7;
    }
    .box-main{
        width: 100%;
        height: calc( 100% - 13vh );
        position: relative;
        background: #fff;
        padding:0.5vh 1vh 0;
    }
    .grey-row{
        background: #F2F2F7;
    }
    .box-head p{
        width: 12vw;
        position: relative;
        text-align: left;
    }
    .nameStyle{
        color: rgb(85, 122, 170);
        cursor: pointer;
    }
    .nameStyle:hover{
        color: #40aaff
    }
    .ul-s{
        width: 80%;
        display: flex;
        text-align: left;
        justify-content: space-between
    }
    .li-16{
        width: 16.7%
    }
</style>

<style>
    @import '../../../assets/css/common.css';
    .el-table .table-head{
        background-color: #F2F2F7;
    }
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>